const today = new Date();

today.setHours(0);
today.setMinutes(0);
today.setSeconds(0);
today.setMilliseconds(0);

export default today;



// WEBPACK FOOTER //
// ./src/gadgets/getToday.js